import VojoApi from './VojoApi'
export default VojoApi
